import Navbar from '../home/components/Navbar';
import FAQ from '../home/components/FAQ';

export default function FAQPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <FAQ />
    </div>
  );
}
